import { Component } from '@angular/core';

@Component({
    selector: 'pdf-alt-text-dialog',
    templateUrl: './pdf-alt-text-dialog.component.html',
    standalone: false
})
export class PdfAltTextDialogComponent {}
